export default __webpack_public_path__ + "static/media/vertical2.6ad3d66f.JPG";